import { Box, Button, Card, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PageHeaderLayout from "../../components/Layout/PageHeaderLayout";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import SduiGuidelines from "./SduiGuidelines";
import SectionItemFormGuidelines from "./SectionItemFormGuidelines";
import SectionFormGuidelines from "./SectionFormGuidelines";
import WeeklyOperationsReportGuidelines from "./WeeklyOperationsReportGuidelines";

export default function GuideLines(){
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'guidelines'
        });
    }, [menuDispatch]);
    const navigate = useNavigate();
      const [tabValue, setTabValue] = useState('0');
      
      // Handle tab change and update URL
      const handleChange = (event, newValue) => {
        setTabValue(newValue);
      };
    return (
      <Box>
        {/* ===========page title================= */}
        <PageHeaderLayout headerTitle={'Guidelines'}>
          <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
            Back
          </Button>
        </PageHeaderLayout>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
              sx={{ p: 0, minHeight: '40px' }}
              variant="scrollable"
              scrollButtons="auto"
            >

              <Tab value="0" label="Sdui" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
              <Tab value="1" label="Section-Item-Form" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
              <Tab value="2" label="Section-Form" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
              <Tab value="3" label="Weekly Report" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            </Tabs>
          </Box>
        </Card>
        {tabValue === '0' && <SduiGuidelines />}
        {tabValue === '1' && <SectionItemFormGuidelines />}
        {tabValue === '2' && <SectionFormGuidelines />}
        {tabValue === '3' && <WeeklyOperationsReportGuidelines />}
      </Box>
    )
}
